class Nav {
  constructor() {
    this.toggleMenuBtn = document.getElementById('toggle-nav')
    this.toggleProjectsBtn = document.getElementById('toggle-projects')
    this.menuWrapper = document.querySelector('#menu_wrapper')
    this.menuLinks = document.querySelectorAll('.menu-item a')
    this.megaDropDown = document.getElementById('mega-drop-down')
    this.megaDropDownOverlay = document.querySelector('.mega-drop-down-overlay')
    this.projectsMenuLink = document.querySelector('.menu-item-object-project')
    this.events()
    this.setActiveMenuLink()
    this.toggleProjectMenu()
  }

  events() {
    // Open and Close the Nav Menu
    this.toggleMenuBtn.addEventListener('click', () => this.toggleNavMenu())

    // Add event listeners for opening and closing project mega menu
    this.toggleProjectsBtn.addEventListener('click', () => {
      const isMegaMenuActive = this.megaDropDown.classList.contains('mega-menu-active')
      this.toggleProjectMenu(!isMegaMenuActive)
    })

    // Open projects mega menu on hover
    this.projectsMenuLink.addEventListener('mouseover', () => this.toggleProjectMenu(true))
    // Close projects mega menu on overlay click
    this.megaDropDownOverlay.addEventListener('click', () => this.toggleProjectMenu(false))
  }

  toggleNavMenu() {
    this.toggleMenuBtn.classList.toggle('active')
    document.body.classList.toggle('noScroll')
    this.menuWrapper.classList.toggle('expand')
  }

  setActiveMenuLink() {
    this.menuLinks.forEach(function (link) {
      if (link.href === window.location.href) {
        link.classList.add('active-highlight')
      }
    })
  }

  toggleProjectMenu(isMouseOver) {
    // Add or remove the "menu-active" class based on mouseover/mouseout
    if (isMouseOver) {
      this.megaDropDown.classList.add('mega-menu-active')
      this.toggleProjectsBtn.classList.add('bg-white')
    } else {
      this.megaDropDown.classList.remove('mega-menu-active')
      this.megaDropDown.classList.remove('bg-white')
    }
  }
}

export default Nav
